import { render, staticRenderFns } from "./HrPerfChargeDetail.vue?vue&type=template&id=3223471e&scoped=true&"
import script from "./HrPerfChargeDetail.vue?vue&type=script&lang=js&"
export * from "./HrPerfChargeDetail.vue?vue&type=script&lang=js&"
import style0 from "./HrPerfChargeDetail.vue?vue&type=style&index=0&id=3223471e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3223471e",
  null
  
)

export default component.exports